import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { useGamificationStore, ACHIEVEMENTS } from '@/store/useGamificationStore';

export function useEngagement() {
  const lastHiddenRef = useRef<number>(0);
  const { newAchievements, clearNewAchievements } = useGamificationStore();

  useEffect(() => {
    const handleVisibility = () => {
      if (document.hidden) {
        lastHiddenRef.current = Date.now();
      } else {
        const elapsed = Date.now() - lastHiddenRef.current;
        if (
          lastHiddenRef.current > 0 &&
          elapsed > 30000 &&
          !window.location.pathname.startsWith('/admin')
        ) {
          toast('Un nouveau défi vous attend !', { icon: '🔥' });
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, []);

  useEffect(() => {
    if (newAchievements.length === 0) return;

    newAchievements.forEach((id, i) => {
      const achievement = ACHIEVEMENTS.find(a => a.id === id);
      if (!achievement) return;
      setTimeout(() => {
        toast.success(`${achievement.icon} ${achievement.name}`, {
          description: achievement.description,
        });
      }, i * 800);
    });

    clearNewAchievements();
  }, [newAchievements, clearNewAchievements]);
}
